import React, { useState, useEffect } from "react";
import ReportTable from "./components/report-table";
import "./reports.css";
import Loading from "../../components/loading";
import { useNavigate, useParams } from "react-router";
import { GetReportInfo } from "../../utils/firebase-config";
const Reports = () => {
  const [loading, setLoading] = useState(true);
  const [report, setReport] = useState(null);
  const { reportId } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    console.log(reportId, "id");
    const fetchReport = async () => {
      const reportInfo = await GetReportInfo(reportId);
      if (reportInfo) {
        setReport(reportInfo);
        setLoading(false);
      } else {
        navigate("/error");
        return;
      }
    };
    fetchReport();
  }, [reportId]);
  return (
    <div className="reports-container">
      {loading ? (
        <Loading text="Loading report..." />
      ) : report ? (
        <ReportTable report={report} />
      ) : null}
    </div>
  );
};

export default Reports;
